import { useRef, useCallback } from 'react';

const MESSAGES = {
  deviation: 'Atención. Te has desviado de la ruta.',
  speed: 'Atención. Exceso de velocidad.',
  return_to_track: 'Has vuelto a la ruta.',
  speed_normalized: 'Velocidad normalizada.',
  stopped: 'Llevas diez minutos parado. ¿Va todo bien?',
  sos: 'Aviso de ayuda enviado al Rally Master.'
};

export function useBeaconAlerts() {
  const audioCtxRef = useRef(null);

  const unlock = useCallback(() => {
    if (!audioCtxRef.current && window.AudioContext) {
      audioCtxRef.current = new window.AudioContext();
    }
    audioCtxRef.current?.resume?.();
    if (window.speechSynthesis) {
      const u = new SpeechSynthesisUtterance(' ');
      u.volume = 0;
      window.speechSynthesis.speak(u);
    }
  }, []);

  const beep = useCallback((pattern) => {
    const ctx = audioCtxRef.current;
    if (!ctx) return;
    let t = ctx.currentTime;
    pattern.forEach(([freq, dur]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'square';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.4, t);
      gain.gain.exponentialRampToValueAtTime(0.001, t + dur);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + dur);
      t += dur + 0.08;
    });
  }, []);

  const speak = useCallback((text) => {
    if (!window.speechSynthesis) return;
    const u = new SpeechSynthesisUtterance(text);
    u.lang = 'es-ES';
    u.rate = 1;
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(u);
  }, []);

  const notify = useCallback((type) => {
    const warning = type === 'deviation' || type === 'speed' || type === 'stopped';
    navigator.vibrate?.(warning ? [400, 150, 400, 150, 400] : [200]);
    beep(warning ? [[880, 0.25], [660, 0.25], [880, 0.25]] : [[660, 0.15], [880, 0.2]]);
    setTimeout(() => speak(MESSAGES[type] || 'Aviso'), 900);
  }, [beep, speak]);

  return { unlock, notify };
}
